import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const StickyApplyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on the 5k-guarantee page (they're already there)
  const isApplicationPage = location.pathname === '/5k-guarantee';
  const isThankYouPage = location.pathname === '/thank-you';
  const isPTAcademyPage = location.pathname === '/pt-growth-academy';

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 600px (past hero section)
      const scrollThreshold = 600;
      setIsVisible(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Check initial scroll position
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goToApplication = () => {
    navigate('/5k-guarantee#application');
  };

  // Don't render on application, thank you, or PT Academy pages
  if (isApplicationPage || isThankYouPage || isPTAcademyPage) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-16 pointer-events-none'
      }`}
    >
      <button
        onClick={goToApplication}
        data-testid="sticky-apply-cta"
        className="group flex items-center gap-3 bg-[#22C55E] hover:bg-[#16A34A] text-black font-bold uppercase tracking-wide rounded-full pl-6 pr-5 py-4 shadow-2xl shadow-[#22C55E]/30 hover:shadow-[#22C55E]/50 transition-all duration-300 hover:-translate-y-1"
      >
        <span className="text-sm md:text-base">Apply Now</span>
        <div className="w-8 h-8 rounded-full bg-black/20 flex items-center justify-center">
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
        </div>
      </button>
      
      {/* Pulse animation ring */}
      <div className="absolute inset-0 rounded-full bg-[#22C55E]/20 animate-ping pointer-events-none" style={{ animationDuration: '2s' }} />
    </div>
  );
};

export default StickyApplyCTA;
